'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _step = require('../components/cartDetail/step1');

var _step2 = _interopRequireDefault(_step);

var _step3 = require('../components/cartDetail/step2');

var _step4 = _interopRequireDefault(_step3);

var _step5 = require('../components/cartDetail/step3');

var _step6 = _interopRequireDefault(_step5);

var _step7 = require('../components/cartDetail/step4');

var _step8 = _interopRequireDefault(_step7);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _actions3 = require('../../customer/actions');

var _actions4 = _interopRequireDefault(_actions3);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

var steps = [_step2.default, _step4.default, _step6.default, _step8.default];

function getStep(stepNumber) {
    return steps[stepNumber - 1] || _step2.default;
}

function mapStateToProps(state) {
    return {
        cart: state.cart,
        contact: state.customer.contact,
        showFreeProductWarning: state.cart.freeProducts && state.cart.selectedFreeProducts && state.cart.freeProducts.length > 0 && state.cart.freeProducts.some(function (f) {
            return f.freeProducts.some(function (ff) {
                return ff.canPurchase === true;
            });
        }) && state.cart.selectedFreeProducts.length === 0
    };
}

var mapDispatchToProps = {
    empty: _actions2.default.empty,
    changeAmount: _actions2.default.changeAmount,
    setStep: _actions2.default.setStep,
    updateCart: _actions2.default.update,
    loadContact: _actions4.default.loadContact,
    sendGtmMetrics: _actions2.default.sendGtmMetrics
};

var CartDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    (0, _inherits3.default)(CartDetail, _React$Component);

    function CartDetail(props) {
        (0, _classCallCheck3.default)(this, CartDetail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CartDetail.__proto__ || (0, _getPrototypeOf2.default)(CartDetail)).call(this, props));

        _this.isActive = function (step) {
            return _this.props.cart.step === step;
        };

        _this.setStep = function (step) {
            setTimeout(function () {
                var showFreeProductWarning = _this.props.showFreeProductWarning;


                var alert = null;

                var alertHandler = function alertHandler(stay) {
                    if (!stay) {
                        alert = null;
                        _this.setState({ warningShown: true }); // disable the warning popup once the user decides to ignore it
                        _this.props.setStep(step);
                    } else {
                        _this.props.setStep(2);
                    }
                };

                if (showFreeProductWarning && step > 2 && !_this.state.warningShown) {
                    alert = function alert() {
                        return sweetAlert({
                            text: Resx.App.FreeProductNotSelectedWarning,
                            type: 'warning',
                            title: Resx.App.FreeProduct,
                            showCancelButton: true,
                            cancelButtonText: Resx.App.DontWantFreeProduct,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: Resx.App.WantChooseFreeProduct
                        }, function (stay) {
                            alertHandler(stay);
                        });
                    };
                }

                if (alert != null) {
                    setTimeout(alert, 50);
                } else {
                    _this.props.setStep(step);
                }
            }, 0);
        };

        _this.navClass = function () {
            var navClass = "cart__navs";
            var step = _this.props.cart.step;
            if (step >= 1) {
                navClass += ' active--step1';
            }
            if (step >= 2) {
                navClass += ' active--step2';
            }
            if (step >= 3) {
                navClass += ' active--step3';
            }
            return navClass;
        };

        _this.state = { warningShown: false };
        return _this;
    }

    (0, _createClass3.default)(CartDetail, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var initialState = JSON.parse(this._root.parentNode.attributes['data-component-props'].value);
            this._root.parentNode.removeAttribute('data-component-props');
            this.props.updateCart((0, _extends3.default)({}, initialState.cart, { step: initialState.step || 1 }));
            // this.props.sendGtmMetrics();

            setTimeout(function () {
                _this2.props.loadContact();
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var loading = !this.props.cart.totalPrice;
            var Step = getStep(this.props.cart.step);
            var stepNo = this.props.cart.step;
            var isStep2Available = (this.props.cart.freeProducts || []).length > 0;
            var stepProps = (0, _extends3.default)({}, this.props, { setStep: this.setStep });
            return _react2.default.createElement(
                'section',
                { className: 'cart cart--1', ref: function ref(e) {
                        return _this3._root = e;
                    }, style: { minHeight: 400 } },
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__nav' },
                        _react2.default.createElement(
                            'div',
                            { className: 'container-fluid' },
                            _react2.default.createElement(
                                'ul',
                                null,
                                _react2.default.createElement(
                                    'li',
                                    { className: stepNo > 1 ? "done" : "active" },
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick() {
                                                return _this3.setStep(1);
                                            }, href: '' },
                                        Resx.App.ShoppingCart
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon--arrow-right' })
                                ),
                                isStep2Available && _react2.default.createElement(
                                    'li',
                                    { className: stepNo > 2 ? "done" : stepNo == 2 ? "active" : "" },
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick() {
                                                return _this3.setStep(2);
                                            } },
                                        Resx.App.FreeProducts
                                    )
                                ),
                                isStep2Available && _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon--arrow-right' })
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: stepNo > 3 ? "done" : stepNo == 3 ? "active" : "" },
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick() {
                                                return _this3.setStep(3);
                                            } },
                                        Resx.App.TransportationAndPaymentTitle
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement('i', { className: 'icon--arrow-right' })
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: stepNo == 4 ? "active" : "" },
                                    _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick() {
                                                return _this3.setStep(4);
                                            } },
                                        Resx.App.Summary
                                    )
                                )
                            )
                        )
                    ),
                    loading ? _react2.default.createElement(
                        'div',
                        { className: 'cart__steps', style: { height: 400 } },
                        _react2.default.createElement('div', { className: 'cart__step cart__step--1 step__loading' })
                    ) : _react2.default.createElement(
                        'div',
                        { className: 'cart__steps' },
                        _react2.default.createElement(Step, stepProps)
                    )
                )
            );
        }
    }]);
    return CartDetail;
}(_react2.default.Component)) || _class);
exports.default = CartDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/cart-detail.js
// module id = 1150
// module chunks = 0